<ng-container *transloco="let t">

  <ng-container *ngIf="ac !== null">

    <div class="layout-header p-d-flex p-ai-center p-jc-between">
      <div>
        <h1>{{ ac.name }} {{ ac.ordernumber }}</h1>
      </div>
      <div *ngIf="auth.isModerator() === true" role="region" aria-label="{{ t('dashboard.controls.ac_controls') }}">
        <button *ngIf="ac.isStartable() && starting !== true" class="p-button-sm" (click)="startAc()" pButton type="button" icon="pi pi-play" label="{{ t('dashboard.controls.start_ac') }}"></button>
        <button *ngIf="ac.isStartable() && starting === true" class="p-button-sm" pButton type="button" label="{{ t('dashboard.controls.start_ac') }}" icon="pi pi-spin pi-spinner" [disabled]="true"></button>
        <button *ngIf="ac.status === 'running' && finishing !== true" (click)="showFinishDialog()" class="p-button-sm" pButton type="button" icon="pi pi-power-off" label="{{ t('dashboard.controls.finish_ac') }}"></button>
      </div>
    </div>

    <div class="layout-content">
      <div class="ac-data" role="region" aria-label="{{ t('dashboard.overview.ac_data') }}">
        <app-date-container></app-date-container>
        <app-video-conference-container></app-video-conference-container>
        <app-participant-container></app-participant-container>
        <app-file-list></app-file-list>
      </div>
      <div class="ac-agenda">
        <div *ngIf="getVisibleMode() !== 'hidden'" role="region" aria-label="{{ t('dashboard.content.agenda') }}">
          <div class="p-grid">
            <div class="p-col-6">
              <app-onlinetest-container [ac]="ac"></app-onlinetest-container>
            </div>
            <div class="p-col-6">
              <app-preparation-container [ac]="ac"></app-preparation-container>
            </div>
          </div>
          <app-agenda></app-agenda>
        </div>
      </div>
      <div *ngIf="ac.isFinished() === true && auth.isModerator() !== true" class="is-finished p-d-flex p-flex-column p-jc-center p-ai-center">
        <fa-icon [icon]="faCheckCircleLight" class="green big-icon"></fa-icon>
        <p>{{ t('dashboard.misc.ac_has_been_finished') }}</p>
      </div>
    </div>

    <core-ui-modal
      [(visible)]="finishVisible"
      [title]="t('dashboard.messages.finish')"
      [icon]="'pi pi-exclamation-triangle'"
    >

      <ng-container [ngSwitch]="finishMode">

        <ng-container *ngSwitchCase="FinishModes.Finish">
          <ng-template #content>
            <p>{{ t('dashboard.messages.should_be_finished') }}</p>
            <p *ngIf="app.hasFeature('runner.resultreport') && ac.has_ai_report === true">{{ t('dashboard.messages.ai_report_hint') }}</p>
          </ng-template>
          <ng-template #footer>
            <div class="p-text-right">
              <button pButton type="button" label="{{ t('common.labels.cancel') }}" (click)="hideFinishDialog()" class="p-button-outlined p-button-secondary"></button>
              <button pButton type="button" label="{{ t('common.labels.finish') }}" (click)="sendFinish()" class="p-ml-2" [icon]="(finishing === true) ? 'pi pi-spinner pi-spin' : 'pi pi-power-off'" [disabled]="(finishing === true) ? true : null"></button>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="FinishModes.Incomplete">
          <ng-template #content>
            {{ t('dashboard.messages.incomplete_intro') }}
            <ul>
              <li *ngFor="let candidate of incompleteCandidates">{{ candidate.fullname }}</li>
            </ul>
            <p>{{ t('dashboard.messages.incomplete_termination') }}</p>
          </ng-template>
          <ng-template #footer>
            <div class="p-grid">
              <div class="p-col-8">
                <button pButton type="button" label="{{ t('dashboard.labels.terminate') }}" (click)="showTerminateDialog()" class="p-button-outlined p-button-secondary"></button>
                <button pButton type="button" label="{{ t('dashboard.labels.to_conference') }}" (click)="gotoConference()" class="p-button-outlined p-button-secondary p-ml-2"></button>
              </div>
              <div class="p-col-4 p-text-right">
                <button pButton type="button" label="{{ t('common.labels.finish') }}" (click)="sendFinish()" class="p-ml-2"></button>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="FinishModes.Terminate">
          <ng-template #content>
            {{ t('dashboard.messages.should_be_terminated') }}
          </ng-template>
          <ng-template #footer>
            <div class="p-text-right">
              <button pButton type="button" label="{{ t('common.labels.cancel') }}" (click)="hideFinishDialog()" class="p-button-outlined p-button-secondary"></button>
              <button pButton type="button" label="{{ t('dashboard.labels.terminate') }}" (click)="sendTerminate()" class="p-button-danger p-ml-2" [icon]="(terminating === true) ? 'pi pi-spinner pi-spin' : 'pi pi-ban'" [disabled]="(terminating === true) ? true : null"></button>
            </div>
          </ng-template>
        </ng-container>

      </ng-container>

    </core-ui-modal>

  </ng-container>

</ng-container>

